import { Transition } from "@headlessui/react";

const Row = ({ title, value }) => {
  return (
    <>
      <div className="">
        <p className="font-semibold text-default pb-3">{title}</p>
        <p className="text-gray">{value}</p>
      </div>
    </>
  );
};

const AdminBlogDetailsModal = ({ show, handleModalClose, data, ...props }) => {
  return (
    <div className="fixed z-10 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <Transition
          show={show}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-black opacity-50"></div>
          </div>
        </Transition>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div
          className="inline-block align-center bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div className="text-right">
            <button
              onClick={handleModalClose}
              className="mt-4 mr-8 px-3 py-1 rounded-full text-lg focus:outline-none bg-white shadow-lg text-secondary"
            >
              x
            </button>
          </div>
          <div className="bg-white px-5 py-1 sm:px-12 sm:py-6">
            <div className="">
              <h3
                className="mb-6 leading-6 text-lg md:text-xl text-primary font-bold"
                id="modal-headline"
              >
                Article Details
              </h3>
              <div className="space-y-6">
                <Row
                  title="Header Image"
                  value={
                    <div className="h-48 w-full rounded-lg object-cover bg-gray-30">
                      <img
                        src={data.contentHeaderImage}
                        className="h-48 w-full rounded-lg object-cover"
                        alt=""
                      />
                    </div>
                  }
                />

                <Row title="Title" value={data.title} />

                <hr className="my-1 border-t border-light-blue" />

                <Row
                  title="Slug"
                  value={
                    data?.slug ? (
                      <code className="text-sm bg-gray-100 px-2 py-1 rounded">
                        {data.slug}
                      </code>
                    ) : (
                      <span className="italic text-gray-400">Not set</span>
                    )
                  }
                />

                <hr className="my-1 border-t border-light-blue" />

                <Row title="Article Category" value={data.category} />

                <hr className="my-1 border-t border-light-blue" />

                <Row
                  title="Meta Title"
                  value={
                    data?.metaTitle ? (
                      <span>
                        {data.metaTitle}{" "}
                        <span className="text-xs text-gray-400 ml-1">
                          ({data.metaTitle.length}/60)
                        </span>
                      </span>
                    ) : (
                      <span className="italic text-gray-400">Not set</span>
                    )
                  }
                />

                <hr className="my-1 border-t border-light-blue" />

                <Row
                  title="Meta Description"
                  value={
                    data?.metaDescription ? (
                      <span>
                        {data.metaDescription}{" "}
                        <span className="text-xs text-gray-400 ml-1">
                          ({data.metaDescription.length}/160)
                        </span>
                      </span>
                    ) : (
                      <span className="italic text-gray-400">Not set</span>
                    )
                  }
                />

                <hr className="my-1 border-t border-light-blue" />
                {/* <Row
                  title="Article Content"
                  value={
                    <div
                      dangerouslySetInnerHTML={convertHTMLStringToHTML(
                        data?.content
                      )}
                    ></div>
                  }
                /> */}

                {/* <hr className="my-1 border-t border-light-blue" /> */}

                <Row
                  title="Created Date"
                  value={new Date(data?.createdAt).toDateString()}
                />

                <div className="flex justify-end mb-3">
                  <button
                    onClick={handleModalClose}
                    className="py-3 px-10 bg-red-600 text-white rounded-md my-3 focus:outline-none"
                  >
                    Close
                  </button>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminBlogDetailsModal;
